import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  constructor() {}

  handleValidationErrors(form: FormGroup, errors: { [key: string]: string }) {
    Object.entries(errors)?.forEach(([field, message]) => {
      const control = form.get(field);
      if (control) {
        control.setErrors({ apiError: message });
        control.markAsTouched();
      }
    });
  }
}
